const VK_APP_ORIGIN = 'https://common-hhpage-backend.hh.ru';
export default VK_APP_ORIGIN;
